export default {
  baseRadius: '.25rem',
  buttonHeight: '2.5rem',
  buttonRadius: 'calc(2.5rem / 2)',
  baseMargin: '1rem',
  maxWidth: 1440
};
